import dayjs from 'dayjs';
// Side-effect import: registers the isoWeek plugin used by the work-week range below.
import '@utils/date';

export type CalendarViewType = 'resourceTimeGridDay' | 'timeGridWeek' | 'timeGridWorkWeek';

/** Number of days the given view shows at once. */
export const daysInView = (view: CalendarViewType): number => {
  if (view === 'timeGridWeek') return 7;
  if (view === 'timeGridWorkWeek') return 5;
  return 1;
};

/**
 * Range used for the opening-hours request. The work-week view snaps to the ISO week start;
 * the other views start at the currently shown date.
 */
export const getDateRange = (currentDate: string, view: CalendarViewType): { dateFrom: string; dateTo: string } => {
  const from = view === 'timeGridWorkWeek' ? dayjs(currentDate).startOf('isoWeek') : dayjs(currentDate);
  const to = from.add(daysInView(view) - 1, 'day');
  return { dateFrom: from.format('YYYY-MM-DD'), dateTo: to.format('YYYY-MM-DD') };
};

/** Days the reservations are fetched for — one request per day is all the API supports. */
export const getDaysArray = (currentDate: string, view: CalendarViewType): string[] => {
  const startDate = dayjs(currentDate).startOf('day');
  return Array.from({ length: daysInView(view) }, (_, i) => startDate.add(i, 'day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'));
};